import config from '../../config';
import { makeAPICall, APIError, getCurrentOrgIdByContext } from '../generalCreators';

export function getInsightSetInsights(insightSetId, isAllocatedTo = true, context = 'global') {
  return function(dispatch, getState) {
    const endpoint = `/insightset/insights/${insightSetId}`;
    const organisationId = getCurrentOrgIdByContext(context, getState);
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        isAllocatedTo
      }
    };

    if (organisationId) {
      options.params.organisationId = organisationId;
    }

    return makeAPICall(endpoint, options).then(
      response => {
        const insights = response.data.insights;
        const type = isAllocatedTo ? 'UPDATE_CURRENT_INSIGHTSET_ALLOCATED_INSIGHTS' : 'UPDATE_CURRENT_INSIGHTSET_UNALLOCATED_INSIGHTS';
        dispatch({ type, insights });
      },
      error => dispatch(APIError(error, 'Error getting currentInsightSet Insights'))
    );
  };
}


export function updateInsightSetInsights(insightSetId, insights) {
  return function(dispatch, getState) {
    const endpoint = `/insightset/insights/${insightSetId}`;
    const options = {
      method: "PUT",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId},
      data: insights
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getInsightSetInsights(insightSetId, true));
        dispatch(getInsightSetInsights(insightSetId, false));
        return response;
      },
      error => dispatch(APIError(error, 'Error updating currentInsightSet Insights'))
    );
  }
}




// WEBPACK FOOTER //
// ./src/actions/insightSets/insightCreators.js